import React from 'react';
import { useDispatch } from 'react-redux';
import { useParams, withRouter } from 'react-router-dom';

import { registerRoutine } from 'state/account/account.routines';

import Page from 'components/page/page.component';

import SignUpForm from 'components/sign-up-form/sign-up-form.component';

import './style.css';

const SignUp = ({ history }) => {
    const dispatch = useDispatch();
    const { inviteCode } = useParams();

    const handleSubmit = (values) => {
        dispatch(registerRoutine.trigger(values));
    };

    const handleSuccess = () => {
        if (history) history.push('/admin/properties');
    };

    return (
        <Page className="account" heroTitle="Create an account" heroSize="small" variant="no-flex">
            <SignUpForm onSubmit={handleSubmit} onSuccess={handleSuccess} inviteCode={inviteCode} />
        </Page>
    );
};

export default withRouter(SignUp);
